"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertMatchesSuppressionRule = void 0;
function alertMatchesTitlePattern(titlePattern, alert) {
    if (!titlePattern) {
        return true;
    }
    const messageLowercase = alert.message?.toLowerCase() ?? "";
    const titlePatternRegex = new RegExp(titlePattern, "i");
    return (messageLowercase.includes(titlePattern.toLowerCase()) ||
        titlePatternRegex.test(alert.message ?? ""));
}
function alertMatchesTagPattern(tagPattern, alert) {
    if (!tagPattern) {
        return true;
    }
    // If there are no details, there can't be a tag match.
    if (!alert.details) {
        return false;
    }
    const tagPatternRegex = new RegExp(tagPattern, "i");
    const testValue = (value) => {
        if (typeof value !== "string") {
            return false;
        }
        const valueLowercase = value?.toLowerCase() ?? "";
        return (valueLowercase.includes(tagPattern.toLowerCase()) ||
            tagPatternRegex.test(value ?? ""));
    };
    if (Object.values(alert.details).some(testValue)) {
        return true;
    }
    return false;
}
/**
 * Check if an alert matches a suppression rule with just the basic rule not considering date of alert, powernode id etc. that would be considered in the entire alert.
 *
 * @param suppressionRule The generalized rule of a suppression.
 * @param alert The alert that would either be suppressed or not suppressed by the rule.
 * @returns Whether the alert would or would not be suppressed by the rule.
 */
function alertMatchesSuppressionRule(suppressionRule, alert) {
    return (alertMatchesTitlePattern(suppressionRule.titlePattern, alert) &&
        alertMatchesTagPattern(suppressionRule.tagPattern, alert));
}
exports.alertMatchesSuppressionRule = alertMatchesSuppressionRule;
